<template>
	<div class="qms-file-upload position-relative w-100">
		<div class="addScroll w-80 mr-5">
			<input type="file" :id="id" @change="onChange" multiple />
			<div class="w-100 pr-4">
				<div class="qms-file-upload__item mr-3" style="text-align: left" v-for="(file, index) in fileNames" :key="index">
					<span class="file-upload__item__name">{{ file }}</span>
					<i class="icon-sf-circle-close" @click="() => deleteFile(index)" />
				</div>
			</div>
		</div>
		<label :for="id" class="unit input-icon"><i class="icon-sf-upload" /></label>
		<label for="upload" class="unit input-icon" style="margin-top: 40px !important"><i class="icon-sf-download" /></label>
	</div>
</template>

<script>
export default {
	props: ['label', 'paramKey', 'id', 'folder'],
	data() {
		return {
			fileNames: [],
			fileList: []
		};
	},
	methods: {
		onChange({ target: { files } }) {
			for (const file of files) {
				this.fileNames.push(file.name);
				this.fileList.push(file);
			}
			//return this.setSearchParam_({ key: this.paramKey, value: this.fileList });
		},
		deleteFile(index) {
			this.fileNames.splice(index, 1);
			this.fileList.splice(index, 1);
		}
	}
};
</script>
